import React from 'react';

interface Props {
  children: any;
}

export const AutoMessageBody = (props: Props) => {
  const { children } = props;
  // message body contains '\n' for new-line expression
  // the white space style make it works same as <br>
  return <div style={{ whiteSpace: 'pre-wrap' }}>{children}</div>;
};
